import React from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import configServ from "../../services/config";
import { toast } from "react-hot-toast";
import ProjectMasterCard from "./ProjectMasterCard";
import ProjectMasterTable from "./ProjectMasterTable";
import { useSelector } from "react-redux";

const ProjectMasterPage = () => {
  //#region
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [projectMasterList, setProjectMasterList] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user_id, company_id } = useSelector((state) => state.GlobalVariables);

  const handlePopup = () => {
    setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
    setIsEdit(false);
  };

  const handleEditData = (data) => {
    setIsEdit(true);
    setIsCreate(true);
    setEditData(data);
  };

  const fetchProjectMaster = async () => {
    setLoading(true);
    try {
        
      const res = await configServ.getAllProjectMasters({company_id:company_id});
      if (res.status === 200) {
        setProjectMasterList(res.data || []);
      } else {
        setProjectMasterList([]);
        toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.error(e);
      setProjectMasterList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectMaster();
  }, []);

  const onDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this ProjectMaster?");
    if (!confirmDelete) return;
  
    try {
        const dataToSend = {
            id : id
        }
      setLoading(true);
      const res = await configServ.  deleteProjectMaster(dataToSend);
      if (res.status === 200) {
        toast.success("ProjectMaster deleted successfully!");
        fetchProjectMaster(); // Refresh the list after deletion
      } else {
        toast.error("Failed to delete ProjectMaster.");
      }
    } catch (e) {
      toast.error("An error occurred!");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  
  //#endregion
  return (
    <Container>
      {/* Header */}
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Project Master"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
        setEditData={setEditData}
      />

      {/* Animated Card */}
      <AnimatePresence>
        {isCreate && (
          <ProjectMasterCard
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editData={editData}
            // clear={clear}
            isCreate={isCreate} // State passed as a prop
            setIsCreate={setIsCreate} // Function passed as a prop
            fetchProjectMaster={fetchProjectMaster} // Pass fetch function
            // permissionsList={permissionsList}
          />
        )}
      </AnimatePresence>
      <ProjectMasterTable
        onDelete={onDelete}
        loading={loading} // Pass the loading state
        projectMasterList={projectMasterList}
        handleEditData={handleEditData}
      />
    </Container>
  );
};

export default ProjectMasterPage;
